import React from 'react';

import { Pill } from '@/components/filters/Pill';
import { YearPicker } from './YearPicker';
import './calendar.css';
import { TAvailableMonths } from './hooks/useReservation';

interface IYearMonthPickerProps {
  selectedMonth: number | null;
  year: number;
  reservation: {
    incrementYear: () => void;
    decrementYear: () => void;
    months: Array<TAvailableMonths>;
    handleChangeMonth: (monthValue: number) => void;
  };
}

export const YearMonthPicker = ({ selectedMonth, year, reservation }: IYearMonthPickerProps) => (
  <section className="flex flex-col gap-6">
    <div className="flex flex-row justify-between items-center w-[364px]">
      <h3 className="text-md font-semibold">What month works for you</h3>
      <YearPicker year={year} increment={reservation.incrementYear} decrement={reservation.decrementYear} />
    </div>
    <div className="flex flex-row flex-wrap gap-2">
      {reservation.months.map((month) => (
        <Pill
          key={month.value}
          label={month.label}
          value={month.value}
          isDisabled={!month.isAvailable}
          className=""
          handleClick={() => reservation.handleChangeMonth(month.value)}
          isSelected={selectedMonth === month.value}
        />
      ))}
    </div>
  </section>
);
